import { useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, History, IdCard, Inbox, User } from 'lucide-react';
import { cn } from '@/lib/utils';
import { TourTarget } from '@/modules/onboarding/constants';

interface NavItem {
  label: string;
  icon: React.FC<{ className?: string }>;
  path: string;
  tourTarget: TourTarget;
  isFab?: boolean;
}

const NAV_ITEMS: NavItem[] = [
  { label: 'Início', icon: LayoutDashboard, path: '/home', tourTarget: TourTarget.Home },
  { label: 'Histórico', icon: History, path: '/punchcard/history', tourTarget: TourTarget.History },
  { label: '', icon: IdCard, path: '/punchcard', isFab: true, tourTarget: TourTarget.Punchcard },
  { label: 'Requerimentos', icon: Inbox, path: '/pleas', tourTarget: TourTarget.Pleas },
  { label: 'Perfil', icon: User, path: '/profile', tourTarget: TourTarget.Profile },
];

export function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-30 border-t border-slate-200 bg-white/80 backdrop-blur-md pb-safe dark:border-slate-700/50 dark:bg-slate-900/85"
      aria-label="Navegação principal"
    >
      <div className="flex h-16 items-center justify-around px-2">
        {NAV_ITEMS.map((item) => {
          const isActive =
            item.path === '/punchcard/history'
              ? location.pathname === '/punchcard/history' || location.pathname === '/punchcard/calendar'
              : location.pathname === item.path;
          const Icon = item.icon;

          if (item.isFab) {
            return (
              <div key={item.path} className="relative -top-5">
                <button
                  onClick={() => navigate(item.path)}
                  data-tour={item.tourTarget}
                  className="flex h-12 w-12 items-center justify-center rounded-full bg-slate-900 text-white shadow-lg shadow-slate-900/20 transition-all active:scale-95 dark:bg-slate-100 dark:text-slate-900 dark:shadow-black/30"
                  aria-label="Registrar ponto"
                >
                  <Icon className="h-5 w-5" />
                </button>
              </div>
            );
          }

          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              data-tour={item.tourTarget}
              className={cn(
                'flex w-16 flex-col items-center gap-1 transition-colors',
                isActive ? 'text-slate-900 dark:text-slate-100' : 'text-slate-400 hover:text-slate-900 dark:text-slate-500 dark:hover:text-slate-100',
              )}
              aria-current={isActive ? 'page' : undefined}
            >
              <Icon className="h-5 w-5" />
              <span className="text-[10px] font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
